import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { InspectionType } from "commons/enum/inspection";
import { numberFormatAsString } from "commons/ultilities";

import { dateTimeDisplay } from "commons/ultilities/date/dayjs";
import { observer } from "mobx-react-lite";
import {
  IInspectionNote,
  IInspectionNoteProperties,
} from "mobx-stores/_models/inspection-note/inspection-note";
import { useStores } from "mobx-stores/_root-store";
import { Fragment, useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  DetailIconButton,
  ExpandButton,
} from "share-components/mui-wrap/button/action-button";
import { XGroupCell } from "share-components/mui-wrap/table/x-group-cell";
import { XSubRow } from "share-components/mui-wrap/table/x-sub-row";
import { XTablePagination } from "share-components/mui-wrap/table/x-table-pagination";
import { getInspectionTypeName } from "..";
export const InspectionNoteTable = observer(() => {
  const {
    inspectionNoteManagement: {
      inspectionNotes,
      getInspectionNotes,
      pagination,
      searchConditionAsNaturalLanguage,
    },
  } = useStores();
  useEffect(() => {
    getInspectionNotes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onPageChanged = useCallback(
    (_: any, page: number) => {
      pagination.setProp("pageIndex", page - 1);
      getInspectionNotes();
    },
    [getInspectionNotes, pagination],
  );

  return (
    <XTablePagination
      paginationProps={{
        count: pagination.totalPages,
        page: pagination.pageIndex + 1,
        onChange: onPageChanged,
      }}
      searchConditionAsNaturalLanguage={searchConditionAsNaturalLanguage}
    >
      <TableHead>
        <TableRow>
          <TableCell></TableCell>
          <TableCell>STT</TableCell>
          <TableCell>Ngày kiểm nghiệm</TableCell>
          <TableCell>Số PKN</TableCell>
          <TableCell>Số Lô Sản Xuất</TableCell>
          <TableCell>Tên khách hàng</TableCell>
          <TableCell>Tên hàng</TableCell>
          <TableCell>Mã hàng</TableCell>
          <TableCell>Loại phiếu</TableCell>
          <TableCell></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {inspectionNotes.map((x, i) => (
          <Row data-id={x.id} key={x.id} inspectionNote={x}></Row>
        ))}
      </TableBody>
    </XTablePagination>
  );
});

type RowProps = {
  inspectionNote: IInspectionNote;
};
const Row = observer(({ inspectionNote }: RowProps) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const goDetailHandler = useCallback(
    (inspectionNote: IInspectionNoteProperties) => {
      if (inspectionNote.type === InspectionType.Stella) {
        navigate(`stella/${inspectionNote.id}`);
        return;
      }

      if (inspectionNote.type === InspectionType.DualLang) {
        navigate(`dual-lang/${inspectionNote.id}`);
        return;
      }
    },
    [navigate],
  );
  return (
    <Fragment>
      <TableRow hover>
        <TableCell sx={{ width: "30px" }}>
          <ExpandButton
            onClick={() => setOpen(!open)}
            open={open}
          ></ExpandButton>
        </TableCell>
        <TableCell>{inspectionNote.orderNumber || ""}</TableCell>
        <TableCell>
          {dateTimeDisplay(inspectionNote.inspectionDate || "")}
        </TableCell>
        <TableCell>{inspectionNote.number || ""}</TableCell>
        <TableCell>
          {inspectionNote.workOrderPO?.woNumber ||
            inspectionNote.workOrder?.woNumber ||
            ""}
        </TableCell>
        <TableCell>{inspectionNote.customer?.name || ""}</TableCell>
        <TableCell>{inspectionNote.items?.[0]?.product?.name || ""}</TableCell>
        <TableCell>{inspectionNote.items?.[0]?.product?.code || ""}</TableCell>
        <TableCell>
          {getInspectionTypeName(inspectionNote.type as InspectionType)}
        </TableCell>
        <TableCell width={"20px"}>
          <DetailIconButton
            onClick={() => goDetailHandler(inspectionNote)}
          ></DetailIconButton>
        </TableCell>
      </TableRow>
      {open && (
        <XSubRow>
          <XGroupCell colSpan={11} headerTitle="Chi tiết mặt hàng">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Ngày đặt hàng</TableCell>
                  <TableCell>Số PO</TableCell>
                  <TableCell>SL Đặt Hàng</TableCell>
                  <TableCell>SL Giao Hàng</TableCell>
                  <TableCell>SL Thùng</TableCell>
                  <TableCell>SL Mẫu Kiểm</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {inspectionNote.items.map((item) => (
                  <TableRow key={item.id}>
                    <TableCell>
                      {dateTimeDisplay(inspectionNote.purchaseOrder?.poDate)}
                    </TableCell>
                    <TableCell>
                      {inspectionNote.purchaseOrder?.poNumber || ""}
                    </TableCell>
                    <TableCell>
                      {numberFormatAsString(
                        inspectionNote.orderQuantity?.toString() || "",
                      )}
                    </TableCell>
                    <TableCell>
                      {numberFormatAsString(
                        inspectionNote.deliveredQuantity?.toString() || "",
                      )}
                    </TableCell>
                    <TableCell>
                      {inspectionNote.packagesQuantity || ""}
                      {/* {numberFormatAsString(
                        inspectionNote.packagesQuantity?.toString() || ""
                      )} */}
                    </TableCell>

                    <TableCell>
                      {inspectionNote.inspectionSamples || ""}
                      {/* {numberFormatAsString(
                        inspectionNote.inspectionSamples?.toString() || ""
                      )} */}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </XGroupCell>
        </XSubRow>
      )}
    </Fragment>
  );
});
